import clsx from 'clsx';
import Link from 'next/link';

import { Icon } from 'common/icon';

import { BreadcrumbsProps, ItemRender } from 'constants/routes-breadcrumbs';

import styles from './styles.module.css';
import BreadcrumbJsonLd from 'components/json-ld';
import { SITE_URL } from 'api/constants';

export const Breadcrumbs = ({
  items,
  name,
  enableAbsoluteOnMobile = false,
  lastEnable = false,
}: {
  items: BreadcrumbsProps[];
  name?: string;
  enableAbsoluteOnMobile?: boolean;
  lastEnable?: boolean;
}) => {
  const itemRender: ItemRender = (route, _params, routes) => {
    const first = routes.indexOf(route) === 0;
    const last = routes.indexOf(route) === routes.length - 1;
    const path = (route as BreadcrumbsProps).path;

    if (last && !lastEnable) {
      return (
        <div className={clsx(styles.breadcrumbs__link)}>
          {first && <Icon.Home />}
          <span>{route.title}</span>
        </div>
      );
    }

    return (
      <Link href={path} className={styles.breadcrumbs__link}>
        {first && <Icon.Home />}
        <span>{route.title}</span>
      </Link>
    );
  };

  return (
    <nav
      className={clsx(
        styles.breadcrumbs,
        enableAbsoluteOnMobile && styles.mobile_absolute
      )}
    >
      <BreadcrumbJsonLd
        breadcrumbs={items.map((item) => {
          return { name: item.title, href: `${SITE_URL}${item.path}` };
        })}
      />

      {items.map((item: BreadcrumbsProps, index) => (
        <span
          key={`${item.path}-${index}`}
          className={clsx({
            [styles.breadcrumbs__item]: true,
            [styles.last]: !name && items?.length - 1 === index,
          })}
        >
          {itemRender(item, {}, items, item.path.split('/'))}
        </span>
      ))}
      {name && (
        <div className={styles.last}>
          <span className={clsx(styles.breadcrumbs__link)}>{name}</span>
        </div>
      )}
    </nav>
  );
};
